function getRealtimeUrl () {
  if (typeof window !== 'undefined' && process.env.REALTIME_HTTP_URL && process.env.REALTIME_HTTPS_URL) {
    return window.location.protocol === 'https:' ? process.env.REALTIME_HTTPS_URL : process.env.REALTIME_HTTP_URL;
  }
  return process.env.REALTIME_URL;
}

module.exports = {
  port : 7777,
  logger: {
    level: 'debug',
    config_file: ''
  },
  realtime: {
    url: getRealtimeUrl()
  },
  cookies : {
    token_cookie_name: process.env.TOKEN_COOKIE_NAME ,
    session_details_cookie_name: process.env.SESSION_DETAILS_COOKIE_NAME,
    domain: '.exploros.com',
    old_cookie_name: 'exploros_token'
  }
};
